import React, { Fragment } from "react";
import ListItem from "@material-ui/core/ListItem";
import IconButton from "@material-ui/core/IconButton";
import ArrowLeft from "@material-ui/icons/ArrowBack";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button/Button";
import List from "@material-ui/core/List";
import Input from "@material-ui/core/Input/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import NumericField from "./NumericField";
import TimeField from "./TimeField";
import { Context } from "./ContextProvider";
import Tooltip from '@material-ui/core/Tooltip';
import * as Helpers from "./Helpers"


import moment from "moment";
import { withWidth } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import ExpandMoreIcon from '@material-ui/icons/MoreHoriz';
import PlaceIcon from "@material-ui/icons/Place";
import MapSelector from "./MapSelector";
import { latLngToString, getDateTimeString, getNow, coordinatesToObj, addItiIds } from "./Helpers";
import { def } from "./Default"
import SelectBox from "./SelectBox";
import { useTranslation } from 'react-i18next';
import * as Logger from "./Logger";

const useStyles = makeStyles(theme => ({

    hideDrawerButton: {
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    toolbar: theme.mixins.toolbar,
    mapSelectorButton: {
        [theme.breakpoints.up('md')]: {
            display: "none",
        }
    },
    input: {
        display: 'none',
    },
    departSelect: { width: 200 },
    departTime: { width: '100%', marginRight: 10 },
    //textField: { paddingTop: 3, paddingBottom: 3 },
    column: {
        flexBasis: '33.33%',
    },
    multilineRow: {
        marginRight: "5%"
    },
    expandedElement: {
        margin: "20px",
        backgroundColor: "#a4c75352",
        borderRadius: "15px",
    }

}));



function QueryForm(props) {
    let { state, dispatch } = React.useContext(Context);
    const [helperOpened, setHelperOpened] = React.useState(false);
    const [pointToMapSelect, setPointToMapSelect] = React.useState();
    // TODO maybe make this a state variable ?
    const isLargeLayout = props.width === "lg" || props.width === "xl";
    const [showAdvancedOptions, setShowAdvancedOptions] = React.useState(false);

    const classes = useStyles();
    const theme = useTheme();
    const { t, i18n } = useTranslation();
    const { motorcycleFuelUsage, minChargeLevel, motivationTo, driverWeight,
        chargeLevel, requestedResults, responseTimeout, energyCost, fuelCost,
        motivationFrom, electricCarIndex, luggageWeight, fuelConsumption, carWeight,
        chargerPlugType, chargerPhases, congestionEnabled, acuCapacity, temperature,
        operatorId, date, mode, maxWalkDistance, maxBikeDistance, weightOptimization,
        time, arriveBy, carEngineType, motorcycleEngineType} = state.query;

    // form data
    const fromPlace = state.startPosition && latLngToString(state.startPosition);
    const toPlace = state.endPosition && latLngToString(state.endPosition);

    const [expandDetailedElectric, setExpandDetailedElectric] = React.useState(false)
    const [expandQueryDetails, setExpandQueryDetails] = React.useState(false);

    // fill battery capacity if empty
    if (state.electricConfig) {
        if (electricCarIndex) {
            const carType = state.electricConfig[electricCarIndex];
            if (!acuCapacity && carType.batteryCapacity) {
                dispatch({
                    type: "updateQuery",
                    payload: {
                        ...state.query,
                        carWeight: carType.weight,
                        acuCapacity: carType.batteryCapacity
                    }
                })
            }

            if (!chargerPlugType && state.electricPlugTypeConfig) {
                let sortedPlugs = state.electricPlugTypeConfig.sort((a, b) => a.priority - b.priority);
                if (carType.ilosc_faz && carType.ilosc_faz === 3) {
                    // restrict 3 phase in case of one phase charge car
                    sortedPlugs = sortedPlugs.filter((plug) => plug.current !== "AC" || (plug.current === "AC" && plug.phase === 3));
                }
                if (sortedPlugs.length > 0) {
                    sendUpdateQuery("chargerPlugType", sortedPlugs[0].id);
                }
            }

            if (!chargerPhases && isPlugAc()) {
                const { query } = state;
                sendUpdateQuery("chargerPhases", carType.ilosc_faz ? carType.ilosc_faz : "1");
            }
        }
    }

    if (!temperature && state.temperatures && state.config && date && time) {
        const month = date.split("-")[1];
        const hour = parseInt(time.split(":")[0]);
        Logger.log("getting default temperature for month " + parseInt(month) + " and hour " + hour);
        const temperatures = state.temperatures[parseInt(month)];
        sendUpdateQuery("temperature", (hour > 8 && hour < 21) ? temperatures.day : temperatures.night);
    }

    if (!operatorId && state.operators) {
        if (state.operators.length > 0)
            sendUpdateQuery("operatorId", state.operators[0].id);
    }

    function setDate(date) {
        dispatch({
            type: "updateQuery", payload: {
                ...state.query,
                date: Helpers.getDateFromDate(date),
                time: Helpers.getTimeFromDate(date),
                temperature: undefined
            }
        })

    }

    function handleNowClicked() {
        setDate(getNow());
    }

    function handleAdvancedClick() {
        setShowAdvancedOptions(!showAdvancedOptions);
    }

    function arrayContains(needle, arrhaystack) {
        return (arrhaystack.indexOf(needle) > -1);
    }

    function setDepartDate(value) {
        Logger.log("Setting depart date")
        Logger.log(value);

        // This is to take default temperature
        setDate(value)
    }

    function constructQuery() {
        return {
            ...state.query,
            fromPlace,
            toPlace,
            alreadyRented: mode === "ELECTRIC_RENTED",
            currentTimestamp: Date.now(),
        }
    }

    function query() {
        // gather data
        const query = constructQuery();

        if (props.onSubmit && typeof props.onSubmit === "function") {
            props.onSubmit(query);
        }
    }

    function selectAFromMap() {
        selectFromMap("start");
    }

    function selectBFromMap() {
        selectFromMap("end");
    }

    function selectFromMap(point) {
        setHelperOpened(true)
        setPointToMapSelect(point);
    }

    function downloadFile(filename, jsonObj) {
        let contentType = "application/json;charset=utf-8;";

        const a = document.createElement('a');
        a.download = filename;
        a.href = 'data:' + contentType + ',' + encodeURIComponent(JSON.stringify(jsonObj));
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    function handleSaveQuery() {
        downloadFile("query_" + getDateTimeString() + ".txt", constructQuery());
    }

    function handleSaveResults() {
        if (state.itineraries) {
            downloadFile("result_" + getDateTimeString() + ".txt", state.itineraries);
        }
    }

    /**
     * Fills form with data from input object, if any data is missing default value is used
     * @param queryData
     */
    function fillForm(queryData) {
        Logger.log("filling form with query data");
        Logger.log(queryData);

        function fill(name) {
            return queryData[name] ? queryData[name] : def[name];
        }

        if (queryData.fromPlace) {
            dispatch({ type: "setStartOnMap", payload: coordinatesToObj(queryData.fromPlace) });
            Helpers.coordinates2addressQuery(coordinatesToObj(queryData.fromPlace), function (result) {
                dispatch({ type: "setStartDisplayName", payload: Helpers.toDisplayAddress(result) });
            });
        }

        if (queryData.toPlace) {
            dispatch({ type: "setEndOnMap", payload: coordinatesToObj(queryData.toPlace) });
            Helpers.coordinates2addressQuery(coordinatesToObj(queryData.toPlace), function (result) {
                dispatch({ type: "setEndDisplayName", payload: Helpers.toDisplayAddress(result) })
            })
        }

        dispatch({ type: "updateQuery", payload: queryData });
    }

    function handleLoadQuery(event) {
        const reader = new FileReader();
        function handleQueryReadasdf(e) {
            Logger.log("Loading query from file");
            Logger.log(reader)
            Logger.log(JSON.parse(reader.result));
            fillForm(JSON.parse(reader.result));
        }

        reader.onloadend = handleQueryReadasdf;

        reader.readAsText(event.target.files[0]);

        event.target.value = "";

    }

    function handleLoadResults(event) {
        const reader = new FileReader();
        reader.addEventListener('load', function () {
            const response = JSON.parse(reader.result)
            Logger.log("Handling loading results");
            Logger.log(response);

            fillForm(response.requestParameters);

            dispatch({ type: "receivedItineraries", payload: addItiIds(response) })
            if (response.plan.itineraries.length > 0) {
                dispatch({ type: "selectIti", payload: response.plan.itineraries[0].id });
            }
            dispatch({ type: "setAppState", payload: "r" })
        });
        reader.readAsText(event.target.files[0]);
        event.target.value = "";
    }

    function getPlug() {
        const current_plug = state.electricPlugTypeConfig.filter(plug => plug.id === chargerPlugType)
        return current_plug && current_plug[0];
    }

    function isPlugAc() {
        if (chargerPlugType) {
            return getPlug().current == "AC";
        }

        return false;
    }

    function clearData() {
        fillForm({});
        dispatch({ type: "setStartOnMap", payload: undefined });
        dispatch({ type: "setEndOnMap", payload: undefined });
        dispatch({ type: "setStartDisplayName", payload: undefined });
        dispatch({ type: "setEndDisplayName", payload: undefined });
    }


    function sendUpdateQuery(keya, value) {
        dispatch({ type: "updateQuery", payload: { ...state.query, [keya]: value } })
    }

    const planClearBtns = <React.Fragment>
        <Button color="secondary" variant="contained" style={{ width: "50%", marginRight: 5 }}
            onClick={query}>{t('Plan trip')}</Button>
        <Button color="secondary" variant="outlined" style={{ width: "50%" }} onClick={clearData}>{t('Clear')}</Button>
    </React.Fragment>
    const map = <MapSelector point={pointToMapSelect} open={helperOpened} handleCancel={() => setHelperOpened(false)} />;
    const form = <React.Fragment>
        <div className={classes.toolbar} />
        {isLargeLayout &&
            <React.Fragment>
                <ListItem>
                    <IconButton
                        color="inherit"
                        aria-label="Search"
                        onClick={() => props.onCloseMenu && props.onCloseMenu()}
                        className={classes.hideDrawerButton}
                    >
                        <ArrowLeft />
                    </IconButton>
                </ListItem>
                <ListItem>
                    {planClearBtns}
                </ListItem>
            </React.Fragment>
        }
        <ListItem>
            <Button color="secondary" variant="outlined" style={{ width: "100%" }} onClick={() => {
                window.location.assign(state.config.dailyTripsUrl);
            }}>{t("Daily Trips")}</Button>
        </ListItem>
        <List>
            <ListItem>
                <SelectBox
                    positionIndex={"A"}
                    InputProps={{
                        startAdornment:
                            <InputAdornment position="start">
                                <Typography color={"primary"} variant={"h6"}>A</Typography>
                            </InputAdornment>,
                        endAdornment:
                            <InputAdornment position="end" className={classes.mapSelectorButton}>
                                <IconButton onClick={selectAFromMap}>
                                    <PlaceIcon />
                                </IconButton>
                            </InputAdornment>
                    }} />
            </ListItem>
            <ListItem>
                <SelectBox
                    positionIndex={"B"}
                    InputProps={{
                        startAdornment:
                            <InputAdornment position="start">
                                <Typography color={"primary"} variant={"h6"}>B</Typography>
                            </InputAdornment>,
                        endAdornment:
                            <InputAdornment position="end" className={classes.mapSelectorButton}>
                                <IconButton onClick={selectBFromMap}>
                                    <PlaceIcon />
                                </IconButton>
                            </InputAdornment>
                    }}
                />
            </ListItem>
            <ListItem>
                <TextField
                    id="selectDepart"
                    select
                    value={arriveBy ? "arrive" : "depart"}
                    className={classes.departSelect}
                    onChange={event => sendUpdateQuery("arriveBy", event.target.value === "arrive")}
                >
                    <option value="depart">{t("Depart")}</option>
                    <option value="arrive">{t("Arrive")}</option>
                </TextField>
                <TextField
                    id="date"
                    className={classes.departTime}
                    type="datetime-local"
                    value={date + "T" + time}
                    onChange={event => setDepartDate(event.target.value)}
                />
                <Button variant="outlined" onClick={handleNowClicked}>{t("Now")}</Button>
            </ListItem>
            <ListItem>
                <FormControlLabel
                    style={{ width: "49%", marginRight: "2%" }}
                    control={
                        <Checkbox
                            checked={congestionEnabled}
                            onClick={event => sendUpdateQuery("congestionEnabled", event.target.checked)}
                        />}
                    label={t("Use congestion data")}
                />

            </ListItem>
        </List>
        <ListItem>
            <TextField
                id="mode"
                select
                label={t("Mode of transport")}
                value={mode}
                onChange={event => { sendUpdateQuery("mode", event.target.value) }}
                style={{ width: "49%", marginRight: "2%" }}
            >
                <option value="WALK">{t("Walk Only")}</option>
                <option value="BICYCLE">{t("Bike Only")}</option>
                <option value="ELECTRIC">{t("Electric Car Only")}</option>
                <option value="ELECTRIC_RENTED">{t("E-car already rented")}</option>
                <option value="WALK,BICYCLE_RENT">{t("Walk and Urban Bike")}</option>
                <option value="WALK,CAR_RENT">{t("Electric car-sharing")}</option>
                <option value="TRANSIT,WALK">{t("Walk and Public Transport")}</option>
                <option value="WALK,BICYCLE_RENT,CAR_RENT,TRANSIT">{t("Walk and Urban Transport")}</option>
                <option value="CAR_PARK,WALK,TRANSIT">{t("Walk and Park & Ride")}</option>
                <option value="BICYCLE_PARK,WALK,TRANSIT">{t("Walk and Bike & Ride")}</option>
                <option value="CAR">{t("Car")}</option>
                <option value="MOTORCYCLE">{t("Motorcycle")}</option>
                <option value="WALK,TRANSIT,CAR,BICYCLE,ELECTRIC,MOTORCYCLE">{t("All")}</option>
            </TextField>

            <TextField
                id="selectDepart"
                select
                label={t("Optimization type")}
                value={weightOptimization}
                onChange={event => {
                    sendUpdateQuery("weightOptimization", event.target.value);
                }}
                style={{ width: "49%" }}
            >
                <option value="QUICKER">{t("Quicker")}</option>
                <option value="SHORTER">{t("Shorter")}</option>
                <option value="GREENER">{t("Greener")}</option>
                <option value="CHEAPER">{t("Cheaper")}</option>
            </TextField>
        </ListItem>

        {(arrayContains(mode, ["ELECTRIC", "WALK,TRANSIT,CAR,BICYCLE,ELECTRIC,MOTORCYCLE", "ELECTRIC_RENTED"])) &&

            <React.Fragment>
                <ListItem>

                    <TextField
                        id="electricCarType"
                        select
                        fullWidth={"true"}
                        label={t("Car")}
                        value={electricCarIndex}
                        onChange={event => {
                            dispatch({
                                type: "updateQuery", payload: {
                                    ...state.query,
                                    electricCarIndex: event.target.value,
                                    acuCapacity: undefined,
                                    chargerPlugType: undefined
                                }
                            })
                        }}
                        className={classes.multilineRow}
                    >
                        {state.electricConfig && Object.keys(state.electricConfig).map((key) => {
                            const car = state.electricConfig[key];
                            const hrk = car.manufacture + (car.model ? " " + car.model : "") + (car.year ? " " + car.year : "") + (car.phases ? " " + car.phases + "(f)" : "")
                            return <option
                                value={key}>{hrk}</option>
                        })}
                    </TextField>


                    <TextField
                        value={chargeLevel}
                        onChange={event => sendUpdateQuery("chargeLevel", event.target.value)}
                        label={t("Charge Level")}
                        fullWidth={"true"}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                        className={classes.multilineRow}
                    />

                    {(arrayContains(mode, ["ELECTRIC", "WALK,TRANSIT,CAR,BICYCLE,ELECTRIC,MOTORCYCLE"])) &&
                        <TextField
                            id="chargerPlugType"
                            select
                            label={t("Charger")}
                            value={chargerPlugType || ''}
                            onChange={event => sendUpdateQuery("chargerPlugType", event.target.value)}
                            fullWidth={true}
                            className={classes.multilineRow}
                        >
                            {state.electricPlugTypeConfig && state.electricPlugTypeConfig.map((charger) => {
                                return <option
                                    value={charger.id}>{charger.type}</option>
                            })}
                        </TextField>}

                    {(arrayContains(mode, ["ELECTRIC_RENTED"])) &&
                        <TextField
                            id="electricCarOperator"
                            select
                            label={t("Car operator")}
                            value={operatorId || ''}
                            onChange={event => sendUpdateQuery("operatorId", event.target.value)}
                            fullWidth={true}
                            className={classes.multilineRow}
                        >
                            {state.operators && state.operators.map((operator) => {
                                return <option
                                    value={operator.id}>{operator.name}</option>
                            })}
                        </TextField>}
                    <Tooltip title={t("More")}>
                        <Button style={{}}
                            onClick={event => setExpandDetailedElectric(!expandDetailedElectric)}> <ExpandMoreIcon /></Button>
                    </Tooltip>
                </ListItem>
            </React.Fragment>
        }
        <div className={classes.expandedElement} style={expandDetailedElectric ? {} : { display: "none" }}>
            <ListItem>
                <TextField
                    value={acuCapacity || ''}
                    onChange={event => sendUpdateQuery("acuCapacity", event.target.value)}
                    label={t("Battery Capacity")}
                    fullWidth={true}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">kWh</InputAdornment>,
                    }}
                    className={classes.multilineRow}
                />
                <Tooltip title="Minimum acceptable car charge level [%]">
                    <TextField
                        value={minChargeLevel}
                        onChange={event => sendUpdateQuery("minChargeLevel", event.target.value)}
                        label={t("Minimum Charge")}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                        fullWidth="true"
                        className={classes.multilineRow}
                    />
                </Tooltip>

                <TextField
                    id="chargerPhases"
                    label={t("Phases")}
                    value={chargerPhases || ''}
                    onChange={event => sendUpdateQuery("chargerPhases", event.target.value)}
                    fullWidth={true}
                    className={classes.multilineRow}
                >
                </TextField>
            </ListItem>
            <ListItem>
                <TextField
                    id="carWeight"
                    label={t("CarWeight")}
                    value={carWeight || ''}
                    onChange={event => sendUpdateQuery("carWeight", event.target.value)}
                    fullWidth={true}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">kg</InputAdornment>,
                    }}
                    className={classes.multilineRow}
                >

                </TextField>
                <TextField
                    value={luggageWeight}
                    onChange={event => sendUpdateQuery("luggageWeight", event.target.value)}
                    label={t("Luggage Weight")}
                    fullWidth={true}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">kg</InputAdornment>,
                    }}
                    className={classes.multilineRow}
                />

                <TextField
                    value={driverWeight}
                    onChange={event => sendUpdateQuery("driverWeight", event.target.value)}
                    label={t("Driver Weight")}
                    fullWidth={true}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">kg</InputAdornment>,
                    }}
                    className={classes.multilineRow}
                />
            </ListItem>

            <ListItem>
                <TextField
                    value={temperature || ""}
                    onChange={event => sendUpdateQuery("temperature", event.target.value)}
                    label={t("Temperature")}
                    fullWidth={true}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">C</InputAdornment>,
                    }}
                    className={classes.multilineRow}
                />
                <TextField
                    value={energyCost}
                    onChange={event => sendUpdateQuery("energyCost", event.target.value)}
                    label={t("Energy cost")}
                    fullWidth={true}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">[gr/kWh]</InputAdornment>,
                    }}
                    className={classes.multilineRow}
                />

            </ListItem>
        </div>

        <ListItem>
            <TextField
                id="motivationFrom"
                select
                label={t("Select motivation from")}
                value={motivationFrom}
                onChange={event => sendUpdateQuery("motivationFrom", event.target.value)}
                fullWidth={true}
                style={{ width: "49%", marginRight: "2%" }}
            >
                <option value="HOME">{t("Home")}</option>
                <option value="WORK">{t("Work")}</option>
                <option value="EDUCATION">{t("Education")}</option>
                <option value="SHOPPING">{t("Shopping")}</option>
                <option value="SERVICE">{t("Service")}</option>
                <option value="DUTY TRAVEL">{t("Duty Travel")}</option>
                <option value="MEDIC">{t("Medic")}</option>
                <option value="AUTHORITY / ADMINISTRATION">{t("Authority / Administration")}</option>
                <option value="SPORT / RECREATION">{t("Sport / Recreation")}</option>
                <option value="ENTERTAINMENT">{t("Entertainment")}</option>
                <option value="OTHER">{t("Other")}</option>
            </TextField>

            <TextField
                id="motivationTo"
                select
                label={t("Select motivation to")}
                value={motivationTo}
                onChange={event => sendUpdateQuery("motivationTo", event.target.value)}
                style={{ width: "49%" }}
            >
                <option value="HOME">{t("Home")}</option>
                <option value="WORK">{t("Work")}</option>
                <option value="EDUCATION">{t("Education")}</option>
                <option value="SHOPPING">{t("Shopping")}</option>
                <option value="SERVICE">{t("Service")}</option>
                <option value="DUTY TRAVEL">{t("Duty Travel")}</option>
                <option value="MEDIC">{t("Medic")}</option>
                <option value="AUTHORITY / ADMINISTRATION">{t("Authority / Administration")}</option>
                <option value="SPORT / RECREATION">{t("Sport / Recreation")}</option>
                <option value="ENTERTAINMENT">{t("Entertainment")}</option>
                <option value="OTHER">{t("Other")}</option>
            </TextField>
        </ListItem>
        <ListItem>
            <Tooltip title={t("More")}>
                <Button style={{ marginLeft: "auto" }}
                    onClick={event => setExpandQueryDetails(!expandQueryDetails)}><ExpandMoreIcon /></Button>
            </Tooltip>
        </ListItem>
        <div className={classes.expandedElement} style={expandQueryDetails ? {} : { display: "none" }}>
            <ListItem>

                {(arrayContains(mode,
                    ["CAR", "CAR_PARK,WALK,TRANSIT", "WALK,TRANSIT,CAR,BICYCLE,ELECTRIC,MOTORCYCLE"])) &&

                    <TextField
                        value={state.metadata.fuelConsumption}
                        onChange={event => sendUpdateQuery("fuelConsumption", event.target.value)}
                        label={t("Car Fuel Usage")}
                        fullWidth={true}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">[l/100km]</InputAdornment>,
                        }}
                    />

                }

                {(arrayContains(mode,
                    ["MOTORCYCLE", "WALK,TRANSIT,CAR,BICYCLE,ELECTRIC,MOTORCYCLE"])) &&
                    <TextField
                        value={state.metadata.motorFuelConsumption}
                        onChange={event => sendUpdateQuery("motorcycleFuelUsage", event.target.value)}
                        label={t("Motorcycle Fuel Usage")}
                        fullWidth={true}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">[l/100km]</InputAdornment>,
                        }}
                    />
                }

                {(arrayContains(mode,
                    ["CAR", "MOTORCYCLE", "CAR_PARK,WALK,TRANSIT", "WALK,TRANSIT,CAR,BICYCLE,ELECTRIC,MOTORCYCLE"])) &&

                    <TextField
                        value={fuelCost}
                        onChange={event => sendUpdateQuery("fuelCost", event.target.value)}
                        label={t("Fuel Cost")}
                        fullWidth={true}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">[gr/l]</InputAdornment>,
                        }}
                    />

                }
            </ListItem>
            <ListItem>
                {(arrayContains(mode,
                    ["CAR", "CAR_PARK,WALK,TRANSIT", "WALK,TRANSIT,CAR,BICYCLE,ELECTRIC,MOTORCYCLE"]))
                     &&
                    <TextField
                        value={carEngineType}
                        select
                        onChange={event => sendUpdateQuery("carEngineType", event.target.value)}
                        label={t("Car Engine Type")}
                        fullWidth={true}
                    >
                         {state.metadata && state.metadata.carEngines && state.metadata.carEngines.map((key) => {
                            return <option
                                value={key}>{key}</option>
                        })}
                    </TextField>
                }
                {(arrayContains(mode,
                    ["MOTORCYCLE", "WALK,TRANSIT,CAR,BICYCLE,ELECTRIC,MOTORCYCLE"]))
                    &&
                    <TextField
                        value={motorcycleEngineType}
                        select
                        onChange={event => sendUpdateQuery("motorcycleEngineType", event.target.value)}
                        label={t("Motorcycle Engine Type")}
                        fullWidth={true}
                    >
                         {state.metadata && state.metadata.motorcycleEngines && state.metadata.motorcycleEngines.map((key) => {
                              return <option
                                value={key}>{key}</option>
                        })}
                    </TextField>
                }
            </ListItem>
            <ListItem>
                {(mode !== "Car") &&
                    <TextField
                        value={maxWalkDistance}
                        onChange={event => sendUpdateQuery("maxWalkDistance", event.target.value)}
                        label={t("Maximum walk distance")}
                        fullWidth={true}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">[m]</InputAdornment>,
                        }}
                    />
                }
                {(arrayContains(mode,
                    ["BICYCLE", "WALK,BICYCLE_RENT", "TRANSIT,WALK", "BICYCLE_PARK,WALK,TRANSIT", "WALK,TRANSIT,CAR,BICYCLE,ELECTRIC,MOTORCYCLE"]))
                    &&
                    <TextField
                        value={maxBikeDistance}
                        onChange={event => sendUpdateQuery("maxBikeDistance", event.target.value)}
                        label={t("Maximum bike distance")}
                        fullWidth={true}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">[m]</InputAdornment>,
                        }}
                    />
                }
            </ListItem>
            <ListItem>
                <NumericField
                    label={t("No of results")}
                    value={requestedResults}
                    onChange={event => sendUpdateQuery("requestedResults", event.target.value)}
                    style={{ width: "49%", margin: "16px", marginRight: "2%" }}
                />

                <TimeField
                    value={responseTimeout}
                    onChange={event => sendUpdateQuery("responseTimeout", event.target.value)}
                    label={t("Timeout")}
                    style={{ width: "49%" }} />
            </ListItem>
        </div>

        <ListItem>
            {planClearBtns}
        </ListItem>
        <ListItem>
            <Button color="secondary" size="small" variant="outlined" style={{ width: "100%" }}
                onClick={handleAdvancedClick}>{t("Load and save options")}</Button>
        </ListItem>
        {showAdvancedOptions && <div>
            <ListItem  >
                <Button style={{ "width": "49%", "marginRight": "2px" }} variant="outlined" disabled={state.itineraries == undefined} onClick={handleSaveResults}
                    size="small">{t("Save Results")}</Button>

                <input

                    accept="*"
                    className={classes.input}
                    id="contained-button-file"
                    multiple
                    type="file"
                    onChange={handleLoadResults}
                />
                <label htmlFor="contained-button-file" style={{ "width": "49%", "marginRight": "2px" }}>
                    <Button style={{ "width": "100%" }} id="contained-button-file" variant="outlined" size="small"
                        component="span">{t("Load results")}</Button>
                </label>
            </ListItem>
            <ListItem>
                <Button style={{ "width": "49%", "marginRight": "2px" }} variant="outlined" size="small" onClick={handleSaveQuery}>{t("Save query")}</Button>

                <input
                    accept="*"
                    className={classes.input}
                    id="contained-button-file2"
                    multiple
                    type="file"
                    onInput={handleLoadQuery}
                />
                <label htmlFor="contained-button-file2" style={{ "width": "49%", "marginRight": "2px" }}>
                    <Button style={{ "width": "100%" }} id="contained-button-file2" variant="outlined" size="small"
                        component="span">{t("Load query")}</Button>
                </label>
            </ListItem>
        </div>
        }
    </React.Fragment>;

    return <div style={{ width: "100%", height: "100%" }}>
        {helperOpened ? map : form}
    </div>;
}

export default withWidth()(QueryForm);
